import SELECTORS from '../../../scripts/utils/vars/selectors';

function handleGiftCardForm() {
  const recipientFormCheckbox = document.querySelector(SELECTORS.PDPRecipientFormCheckbox);
  if (!recipientFormCheckbox) return;

  // Hide the label next to the recipient checkbox (optional UI tweak)
  const recipientFormCheckboxLabel = document.querySelector(`#${recipientFormCheckbox.id} + label`);
  if (recipientFormCheckboxLabel) recipientFormCheckboxLabel.classList.add('d-none');

  const giftCardTypes = document.querySelectorAll(SELECTORS.productTypeVariant);
  if (!giftCardTypes.length) return;

  const updateRecipientFormVisibility = () => {
    const selectedType = [...giftCardTypes].find(input => input.checked)?.value;

    if (selectedType === 'Email') {
      if (!recipientFormCheckbox.checked) recipientFormCheckbox.click(); // Ensure it's visible
    } else {
      if (recipientFormCheckbox.checked) recipientFormCheckbox.click(); // Hide it
    }
  };

  // Attach event listener to all gift card type inputs
  giftCardTypes.forEach(input => {
    input.addEventListener('change', updateRecipientFormVisibility);
  });

  // Run initially on page load
  updateRecipientFormVisibility();
}


function handleAmountDropdown() {
  const PDPGiftCardTypeVariantOptions = document.querySelectorAll(SELECTORS.PDPGiftCardTypeVariantOptions);
  const PDPAmountVariant = document.querySelector(SELECTORS.PDPAmountVariant);    
  if (!PDPGiftCardTypeVariantOptions || !PDPAmountVariant) return;
  
  PDPGiftCardTypeVariantOptions.forEach(option => {
    if (option.hasAttribute('show-amount-full-width')) {
      const input = option.parentElement.querySelector('input');
      if (input && input.checked) PDPAmountVariant.classList.add('full-width');
    }

    option.addEventListener('click', () => {
      if (option.hasAttribute('show-amount-full-width')) {
        PDPAmountVariant.classList.add('full-width');
      } else {
        PDPAmountVariant.classList.remove('full-width');
      }
    });
  });
  
}

handleGiftCardForm();
handleAmountDropdown();